var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3889 14.1111L16 10.5M16 10.5L12.3889 6.88889M16 10.5H7.33333M7.33333 4H6.46667C5.25322 4 4.6465 4 4.18302 4.23615C3.77534 4.44388 3.44388 4.77534 3.23615 5.18302C3 5.6465 3 6.25322 3 7.46667V13.5333C3 14.7468 3 15.3535 3.23615 15.817C3.44388 16.2247 3.77534 16.5561 4.18302 16.7638C4.6465 17 5.25322 17 6.46667 17H7.33333",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.6f9036dfca30880d540633f4f196e3db.svg";
export { ForwardRef as ReactComponent };